"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: grid;\n  row-gap: 15px;\n  column-gap: 15px;\n  grid-template-columns: repeat(3, 1fr);\n  button:nth-child(4) {\n    grid-column-start: 1;\n    grid-column-end: 4;\n  }\n  & + * {\n    margin-top: 90px;\n  }\n"])));

exports.Container = Container;